import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Box } from "@mui/system";
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  TextField,
} from "@mui/material";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import { getDocumentById, uploadDocuments } from "_controllers/officer";
import axios from "axios";
import dotenv from "dotenv";
import { useHistory, useParams } from "react-router-dom";

dotenv.config();

const Main = () => {
  const history = useHistory();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [image, setImage] = useState("");
  const [Values, setValues] = useState({
    documentCategory: "",
    imageUrl: "",
    description: "",
  });
  const [imageLoading, setimageLoading] = useState(false);

  useEffect(async () => {
    const requests = await getDocumentById(id);
    setValues({
      ...Values,
      documentCategory: requests?.doc.documentCategory,
      description: requests?.doc.description,
    });
    setLoading(true);
  }, [message]);

  const { documentCategory, imageUrl, description } = Values;

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("submit", image);
    let formData = new FormData();
    if (image) {
      if (image.type !== "application/pdf")
        return alert("Upload PDF Files Only.");
      formData.append("file", image);
      formData.append("fileName", image.name);
    }

    formData.append("description", Values.description);
    formData.append("category", Values.documentCategory);
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const url = process.env.REACT_APP_REQUEST_ENDPOINT;
    await axios
      .put(`${url}/api/v1/document/${id}`, formData, config)
      .then((res) => {
        // setImage("");
        // setMessage(res?.data?.message);
        // console.log("object", res);
        toastMessage(res?.data?.message, "success");
        history.push("/upload-documents");
      })
      .catch((err) => {
        setImage("");
        setMessage(err?.message);
        toastMessage(message, "error");
      });
  };

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value });
  };

  const saveImg = async (e) => {
    setImage(e.target.files[0]);
  };

  console.log("ji", Values);

  return (
    <>
      <Box
        style={{
          padding: "0px 20px",
          border: "1px solid #eaeaea",
          borderRadius: "10px",
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
          // marginTop: "10px",
          marginRight: "20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Grid>
          <p style={{ fontWeight: "bolder", fontSize: "1.25rem" }}>
            Edit Document
          </p>
        </Grid>
      </Box>

      <Box
        style={{
          marginRight: "20px",
          marginTop: "20px",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid
            container
            xs={12}
            spacing={1}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Grid item xs={3}>
              <h3>Document Type</h3>
            </Grid>
            <Grid item xs={9}>
              <TextField
                onChange={handleChange}
                value={documentCategory}
                name="documentCategory"
                label="Doc Type"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={3}>
              <h3>Description</h3>
            </Grid>
            <Grid item xs={9}>
              <TextField
                onChange={handleChange}
                value={description}
                name="description"
                label="Description"
                variant="outlined"
              />
            </Grid>

            <Grid item xs={4}>
              <FormControl width={"50%"}>
                <TextField
                  onChange={saveImg}
                  InputProps={{
                    disableUnderline: true,
                  }}
                  type={"file"}
                  id="standard-basic"
                  label="Image"
                  name="image"
                  variant="standard"
                  style={{ border: "0" }}
                />
              </FormControl>
              {/* {imageLoading ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress />
                  </Box>
                ) : null}
                {Values.image ? "uploaded !" : null} */}
            </Grid>
          </Grid>
          <br />
          <Grid xs={6}>
            <Button type="submit" variant="contained">
              Submit
            </Button>
          </Grid>
        </form>
      </Box>
    </>
  );
};

const EditDocument = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default EditDocument;
